import { render } from "./ClaimResultSubmissionKeepPrivate.vue?vue&type=template&id=039bc220&scoped=true"
import script from "./ClaimResultSubmissionKeepPrivate.vue?vue&type=script&lang=js"
export * from "./ClaimResultSubmissionKeepPrivate.vue?vue&type=script&lang=js"

import "./ClaimResultSubmissionKeepPrivate.vue?vue&type=style&index=0&id=039bc220&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039bc220"]])

export default __exports__